import React, { FC } from "react";
import EChartsReact from "echarts-for-react";
import { dataEntry, IDataTest } from "../../types/types";

import {
    Paper
} from "@material-ui/core";
import { trafficLight } from "../../theme";
import { number } from "echarts";


interface IFMChartProps {
    data: any
}


const ConfidenceChart: FC<IFMChartProps> = ({ data }) => {

    let left = 75
    // if (data.title === 'Bar Chart') {
    //     left = 200;
    // }

    // const height = data.height ? data.height : "250px";

    const cat = ['1', '2', '3', '4'];
    const cat_name = ['Very Strong', 'Strong', 'Weak', 'Very Weak'];
    const cat_colour = [trafficLight.green, trafficLight.cmgreen, trafficLight.cmyellow, trafficLight.cmred];

    const valueData = cat.map((index: any) => {
        
        const d = data.data.map((entry: any) => {
            // return dict with value and colour
            return {
                value: entry.values[Number(index)],
                // itemStyle: {
                //     color: cat_colour[Number(index) -1]
                // }
            }}
   
        )



        return {
            type: 'bar',
            data: d,
            stack: 'total',
            name: cat_name[Number(index) -1],
            
            
            emphasis: {
                focus: 'series'
              }
            }
        }
    )

    

    const categoryData = data.data.map((entry: any) => {
        return Number(entry.index) +1
    })




    const getOption = () => {

        return {
            color: cat_colour,
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    // Use axis to trigger tooltip
                    type: 'none' // 'shadow' as default; can also be 'line' or 'shadow'
                },
                backgroundColor: 'rgba(255,255,255,0.7)',
            },
            title: {
                text: "Confidence below Safety Threshold",
                left: 'center',
                textStyle: {
                    color: 'black'
                }

            },
            toolbox: {
                show: true,
                top: 0,
                feature: {
                    saveAsImage: {
                        show: true,
                        pixelRatio: 4
                    },
                    dataView: {
                        show: true,
                        readOnly: false

                    }
                },

            },
            legend: {
                bottom: 'bottom'
            },

            grid: {
                left: left,
                right: '20',
                bottom: '60',
                top: '40',
                containLabel: false
            },
            xAxis: {
                type: 'category',
                name: 'Order',
                nameGap: 25,
                nameLocation: 'middle',

                data : categoryData
            },
            yAxis: {
                type: 'value',
                name: "Number of Dams"
            },
            series: 

                   valueData,
   
                    

        };
    }

    return (<>
        <div style={{ padding: "10px" }}>
            <Paper variant={"outlined"}>
                <EChartsReact option={getOption()} style={{ height: 300 }} />
            </Paper>
        </div>

    </>
    );
}

export default ConfidenceChart;
